import { render } from "./UnregisterCompleteEnd.vue?vue&type=template&id=281b00c0"
import script from "./UnregisterCompleteEnd.vue?vue&type=script&lang=js"
export * from "./UnregisterCompleteEnd.vue?vue&type=script&lang=js"

import "./UnregisterCompleteEnd.vue?vue&type=style&index=0&id=281b00c0&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__